import { render, staticRenderFns } from "./DatePickers.vue?vue&type=template&id=2b308cf2&scoped=true&"
import script from "./DatePickers.vue?vue&type=script&lang=ts&"
export * from "./DatePickers.vue?vue&type=script&lang=ts&"
import style0 from "./DatePickers.vue?vue&type=style&index=0&id=2b308cf2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b308cf2",
  null
  
)

component.options.__file = "DatePickers.vue"
export default component.exports